// Format tanggal untuk tampilan & export: dd/mm/yyyy. Database TETAP
// menyimpan yyyy-mm-dd (kolom DATE/DATEONLY), jadi helper ini hanya
// mengubah cara tanggal ditampilkan, bukan data yang dikirim ke backend.

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
const DMY_DATE = /^(\d{2})\/(\d{2})\/(\d{4})$/;

const dmyFormatter = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "Asia/Jakarta",
});

// "1983-06-26" → "26/06/1983". Timestamp penuh (createdAt, paidAt, ...)
// dikonversi ke zona Asia/Jakarta dulu supaya tanggalnya tidak bergeser.
// Nilai kosong/tidak valid → "".
export const formatDmy = (value) => {
  if (!value) return "";
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? "" : dmyFormatter.format(value);
  const str = String(value);
  const iso = str.match(ISO_DATE);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  const d = new Date(str);
  if (Number.isNaN(d.getTime())) return str;
  return dmyFormatter.format(d);
};

// "26/06/1983" → "1983-06-26"; "" bila belum lengkap atau tanggalnya
// tidak ada (mis. 31/02/2000).
export const dmyToIso = (text) => {
  const m = String(text || "").match(DMY_DATE);
  if (!m) return "";
  const [, dd, mm, yyyy] = m;
  const d = new Date(Date.UTC(Number(yyyy), Number(mm) - 1, Number(dd)));
  if (d.getUTCFullYear() !== Number(yyyy) || d.getUTCMonth() !== Number(mm) - 1 || d.getUTCDate() !== Number(dd)) {
    return "";
  }
  return `${yyyy}-${mm}-${dd}`;
};

// Ketikan bebas → "dd/mm/yyyy" dengan garis miring otomatis.
export const maskDmy = (text) => {
  const digits = String(text || "").replace(/\D/g, "").slice(0, 8);
  if (digits.length > 4) return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
  if (digits.length > 2) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return digits;
};

// Kelas yang ditandai Paid oleh admin tanpa tahu tanggal bayarnya
// (classList[].paidDateUnknown) — paidAt-nya kosong, ditampilkan begini.
export const UNKNOWN_PAID_DATE = "00-00-0000";

// Tanggal bayar sebuah kelas untuk tampilan: "dd/mm/yyyy", "00-00-0000" kalau
// admin tidak tahu tanggalnya, atau "" kalau memang tidak ada.
export const formatPaidDate = (paidAt, unknown) => (unknown ? UNKNOWN_PAID_DATE : formatDmy(paidAt));

// Tanggal hari ini untuk nama file export ("30-09-2026") — "/" tidak
// boleh dipakai di nama file.
export const fileDateStamp = () => formatDmy(new Date()).replace(/\//g, "-");
